import { useEffect, useState, useRef } from "react";
import { firestore, storage } from "../firebase.js";
import { collection, doc, addDoc, getDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { v4 as uuidv4 } from 'uuid';
import { Link } from "react-router-dom";
import LogoImageUrl from '../asset/logos.png';
import RadioGroup from "./components/RadioGroup";
import Radio from "./components/Radio";
import Agreebox from "./components/Agreebox";
import Logo from '../asset/logos.png'
import emailjs from '@emailjs/browser';
import '../css/Purchase.css';
import '../css/Result.css';
import '../css/modal.css';

function PurchaseForm() {

      //견적용 날짜 포매팅
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}년 ${month}월 ${day}일`;
  };


const [page, setPage] = useState(0);
let timeoutId;

const [isModalOpen, setIsModalOpen] = useState(false);

const [products, setProducts] = useState([
    {
      id: Date.now(),
      name: '',
      option: '',
      quantity: '',
      price: '',
      cndelivery: '',
      link: '',
      image: null,
    },
  ]);

  const handleInputChange = (index, field, value) => {
    const updated = [...products];
    updated[index][field] = value;
    setProducts(updated);
  };

  const handleImageUpdate = (index, url) => {
    const updated = [...products];
    updated[index].image = url;
    setProducts(updated);
  };

  const addProduct = () => {
    if (products.length >= 10) return;
    setProducts([
      ...products,
      {
        id: Date.now(),
        name: '',
        option: '',
        quantity: '',
        price: '',
        cndelivery: '',
        link: '',
        image: null,
      },
    ]);
  };

  const removeProduct = (index) => {
    if (index === 0) return;
    const updated = [...products];
    updated.splice(index, 1);
    setProducts(updated);
  };


const openModal = () => setIsModalOpen(true);
const closeModal = () => setIsModalOpen(false);

function DualSectionImageUploader({ image, onImageChange, onRemove }) {
    const fileInputRef = useRef(null);
    const pasteRef = useRef(null);
  
    useEffect(() => {
      const handlePaste = (e) => {
        if (!pasteRef.current || !pasteRef.current.contains(document.activeElement)) return;
  
        const items = e.clipboardData?.items;
        if (!items) return;
  
        for (const item of items) {
          if (item.type.indexOf('image') !== -1) {
            const blob = item.getAsFile();
            if (blob) {
              const url = URL.createObjectURL(blob);
              onImageChange(blob, url);
            }
          }
        }
      };
  
      window.addEventListener('paste', handlePaste);
      return () => window.removeEventListener('paste', handlePaste);
    }, [onImageChange]);
  
    if (image) {
      return (
        <div
          style={{
            width: '200px',
            height: '200px',
            position: 'relative',
            borderRadius: '6px',
            overflow: 'hidden',
            margin: 'auto',
          }}
        >
          <img
            src={image}
            alt="미리보기"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
          <button
            onClick={onRemove}
            style={{
              position: 'absolute',
              top: '4px',
              right: '4px',
              background: 'rgba(0,0,0,0.6)',
              color: '#fff',
              border: 'none',
              borderRadius: '50%',
              width: '20px',
              height: '20px',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            ×
          </button>
        </div>
      );
    }
  
    return (
      <div
        style={{
          display: 'flex',
          width: '200px',
          height: '200px',
          margin: 'auto',
          border: '1px dashed #ccc',
          borderRadius: '6px',
          overflow: 'hidden',
        }}
      >
        {/* 왼쪽: 클릭 첨부 영역 */}
        <div
          onClick={() => fileInputRef.current.click()}
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f0f0f0',
            fontSize: '12px',
            cursor: 'pointer',
            borderRight: '1px solid #ccc',
          }}
        >
          제품 이미지 첨부
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) {
                const url = URL.createObjectURL(file);
                onImageChange(file, url);
              }
            }}
          />
        </div>
  
        {/* 오른쪽: 붙여넣기 영역 */}
        <input
          ref={pasteRef}
          tabIndex={0}
          placeholder="Ctrl+V 붙여넣기"
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: "0px",
            backgroundColor: '#f9f9f9',
            fontSize: '12px',
            outline: 'none',
            margin: 'auto',
            cursor: 'text',
          }}
        />
      </div>
    );
  }
const [prds, setPrds] = useState("");

useEffect(() => {
    if (products.length === 0 || !products[0].name.trim()) {
      setPrds("");
    } else if (products.length === 1) {
      setPrds(products[0].name);
    } else {
      setPrds(`${products[0].name} 외 ${products.length - 1}건`);
    }
  }, [products]);

const [c, setC] = useState("");
const [e, setE] = useState("");
const [f, setF] = useState("");
const [g, setG] = useState("");

// const [address, setAddress] = useState("");
// const [code, setCode] = useState("");
// const [take, setTake] = useState("");
// const [cnCall, setCnCall] = useState("");

// const [cndelivery, setCndelivery] = useState("");

const [way, setWay] = useState('1688');

const [b, setB] = useState("");
const [cnLink, setCnLink] = useState([""]);

const [owner, setOwner] = useState("");
const [bank, setBank] = useState("");
const [paycode, setPaycode] = useState("");


const [i, setI] = useState("");
const [j, setJ] = useState("");
const [k, setK] = useState("");
const [l, setL] = useState("");
const [m, setM] = useState(false);

const [z, setZ] = useState("");

const [t, setT] = useState("");

const [p, setP] = useState("");
const [q, setQ] = useState("");
const [r, setR] = useState("");

const [w, setW] = useState("");
const [x, setX] = useState("");
const [y, setY] = useState("");
const [o, setO] = useState("");

const [rr, setRr] = useState(""); 

const [result, setResult] = useState(null); 
const [date, setDate] = useState(''); 

const [loading, setLoading] = useState(false)



    useEffect(() => {
        setDate(formatDate(new Date()));
      }, []);




      const calC = async (event) => {
        try {
            const docRef = doc(firestore, 'purchase_admin', 'bigpie');
            const docSnapshot = await getDoc(docRef);
    
            if (docSnapshot.exists()) {
                const { w, x, y, z, v } = docSnapshot.data();
    
                let calculatedO;
                if (i <= v) {
                    calculatedO = w;
                } else {
                    calculatedO = Math.round(i * z * x);
                }
    
                const calculatedT = Math.round(i * z);
                const calculatedP = Math.floor(calculatedO * y);
                const calculatedQ = Math.round(i * z + calculatedO);
                const calculatedR = Math.round(calculatedQ + calculatedP);

                setZ(z);
                setP(calculatedP);
                setQ(calculatedQ);
                setR(calculatedR);
                setW(w);
                setX(x);
                setY(y);
                setO(calculatedO);
                setT(calculatedT);
    
            } else {
                console.error('Document not found');
            }
        } catch (error) {
            console.error('Error fetching document:', error);
        }
    };



async function handleNextClick() {

    if (!m) {
        alert("주의사항에 동의해주세요");
        return;
    } if (way === '1688' && (!c || !e || !f || !g || !i || !k || !b || !cnLink[0])) {
        alert("필수 항목을 모두 입력해주세요");
        return;
    } if (way === 'normal' && (!c || !e || !f || !g || !i || !k || !owner || !bank || !paycode)) {
        alert("필수 항목을 모두 입력해주세요");
        return;
    }

    setLoading(true);
    try {
        await calC();
    } catch (error) {
        console.error('Error in calC function:', error);
    } finally {
        setLoading(false);
    }

    setPage((currPage) => currPage + 1); 
    window.scrollTo({ top: 0 }); 
};
  


const onSubmit = async (event) => {
    event.preventDefault();

    if (!r) {
        alert("잠시만 기다려주세요");
        return;
    }
    if (!c || !e || !f || !g || !i || !k) {
        alert("필수 항목을 모두 입력해주세요");
        return;
    }

        alert("완료되었습니다");
        const uniqueFolder = uuidv4(); 

        try {

            setLoading(true);
            
            setRr(r);

            setTimeout(async () => {
                const canvasElement = await html2canvas(document.querySelector('.prcCanvas'));
                const imageData = canvasElement.toDataURL('image/png');
                const imgWidth = 210;
                const pageHeight = 295;
                const imgHeight = (canvasElement.height * imgWidth) / canvasElement.width;
                let heightLeft = imgHeight;
        
                const pdfDoc = new jsPDF('p', 'mm', 'a4', true);
                let position = 0;
        
                pdfDoc.addImage(imageData, 'PNG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
                heightLeft -= pageHeight;
        
                while (heightLeft >= 0) {
                  position = heightLeft - imgHeight;
                  pdfDoc.addPage();
                  pdfDoc.addImage(imageData, 'PNG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
                  heightLeft -= pageHeight;
                }
        
                const pdfBlob = pdfDoc.output('blob');


        
            const metadata = {

                contentType: 'application/pdf',

                contentDisposition: `inline; filename="중달이 결제대행 견적서_${c}님_${date}.pdf"`,
            };

                    // Firebase Storage에 PDF 업로드
                    const pdfFileRef = ref(storage, `prcRegister/${uniqueFolder}/results/result.pdf`);
                    await uploadBytes(pdfFileRef, pdfBlob, metadata);
                    const uploadedPdfFileURL = await getDownloadURL(pdfFileRef);
                    setResult(uploadedPdfFileURL); 


                //     const uploadedProducts = await Promise.all(
                //         products.map(async (product, index) => {
                //         let imageUrl = '';
                //         if (product.image) {
                //             const imageRef = ref(storage, `prcRegister/${uniqueFolder}/products/${index}.jpg`);
                //             const response = await fetch(product.image);
                //             const blob = await response.blob();
                //             await uploadBytes(imageRef, blob);
                //             imageUrl = await getDownloadURL(imageRef);
                //         }

                //         return {
                //             name: product.name,
                //             option: product.option,
                //             quantity: product.quantity,
                //             price: product.price,
                //             cndelivery: product.cndelivery,
                //             link: product.link,
                //             imageUrl: imageUrl || null,
                //         };
                //         })
                //     );

                //     const productSummary = uploadedProducts
                //         .map((p, i) => 
                //         `🔹 제품 #${i + 1}
                // - 이름: ${p.name}
                // - 옵션: ${p.option}
                // - 수량: ${p.quantity}
                // - 단가: ${p.price}
                // - 중국 현지 운임: ${p.cndelivery}
                // - 링크: ${p.link}
                // - 이미지: ${p.imageUrl}
                // `
                //         )
                //         .join('\n');



        await addDoc(collection(firestore, "purchase"), {

          id: b,
          prcName: c,
          phone: e,
          email: f,
          jungdari: g,
          way: way,

          cnLink: cnLink,
          owner: owner,
          bank: bank,
          paycode: paycode,

          total: i,
          delivery: k,
          note: l,
          agree: m,
          prdPrice: t,
          tax: p,
          estimate: q,
          totalPrice: r,

          z: z,
          taxRate: y,
          fee: o,
          feeRate: x,
          minimumFee: w,
          result: uploadedPdfFileURL,
          state: "의뢰요청",

          timestamp: new Date(),
        });

        
      const templateParams = {

        id: b,
        prcName: c,
        phone: e,
        email: f,
        jungdari: g,
        way: way,
        
        cnLink: cnLink.join('\n'),
        owner: owner,
        bank: bank,
        paycode: paycode,

        total: i,
        delivery: k,
        note: l,
        agree: m,
        prdPrice: t,
        tax: p,
        estimate: q,
        totalPrice: r,

        z: z,
        taxRate: y,
        fee: f,
        feeRate: x,
        minimumFee: w,
        state: "의뢰요청",

        timestamp: new Date(),
        uploadedPdfFileURL,
    };

    //darlibaba06@gmail.com
    emailjs.send('service_mp685ax', 'template_s4a03eb', templateParams, 'etcL6FhB6gHZjSLnB')
    .then((result) => {
        console.log(result.text);

        setTimeout(() => setPage(currPage => currPage + 1), 0);
        window.scrollTo({ top: 0 });

    }, (error) => {
        console.log(error.text);
    });

    }, 0);

    } catch (error) {
    console.error('Error', error);
    }
    };



useEffect(() => {
    return () => clearTimeout(timeoutId);
  }, []);


      //핸드폰
      const handlePhoneChange = (e) => {
        const phoneNum = e.target.value;
        setE(phoneNum
          .replace(/[^0-9]/g, '')
          .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
          .replace(/(\-{1,2})$/g, "")
        );
      }

            //값에 콤마
            const valueComma = (feeNum) => {
                return feeNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              }


                const handleLinkChange = (index, value) => {
                    const newLink = [...cnLink];
                    newLink[index] = value;
                    setCnLink(newLink);
                };

                const handleAddLink = () => {
                    if (cnLink.length >= 20) {
                    alert("최대 20개까지 추가할 수 있습니다.");
                    return;
                    }
                    setCnLink([...cnLink, ""]);
                };

                const handleRemoveLink = (index) => {
                    if (index === 0) return;
                    const newLink = [...cnLink];
                    newLink.splice(index, 1);
                    setCnLink(newLink);
                };



const Pages = () => {
    if (page === 0) {
        return(
            <div className="purchase-form-body">

            {loading && <div className="loading">
                        <span></span> 
                        <span></span>
                        <span></span>  
                        </div>}
                
                <div className="intro-info" >
                    결제대행 신청
                </div>
                <div className="intros-info" >
                    신청자 정보 입력
                </div>
                <div className="user-info" >
                <div className="information">
                    <div className="info">신청자명</div>
                    <input placeholder="입금자명(또는 사업자명)으로 기재해주세요." value={c} onChange={(event) => (setC(event.target.value))}/>
                </div>
                <div className="information">
                <div className="info">연락처</div>
                    <input placeholder="연락처를 입력해주세요" value={e} type="text" spellCheck="false" maxLength={13} onChange={handlePhoneChange}/>
                </div>
                <div className="information">
                <div className="info">이메일</div>
                    <input placeholder="견적서를 전달 받을 이메일 주소를 입력해주세요" value={f} type="text" spellCheck="false" onChange={(event) => (setF(event.target.value))}/>
                </div>
                <div className="information">
                <div className="info">중달이닷컴 아이디</div>
                    <input placeholder="중달이닷컴 회원가입 후 서비스 이용해주세요" value={g} onChange={(event) => (setG(event.target.value))}/>
                </div>
                </div>
                
                <div className="intros-info" >
                    신청방법
                </div>
                <div className="user-info" >
                    <div style={{display:"flex"}}>
                        <label style={{display:"flex", marginLeft: '1rem'}}>
                        <input
                            type="checkbox"
                            checked={way === '1688'}
                            value="1688"
                            onChange={() => setWay('1688')}
                            style={{width:"15px", height:"20px", cursor:"pointer"}}
                        />
                        <div style={{margin:"auto", marginLeft: '0.5rem'}}>1688 결제</div>
                        </label>

                        <label style={{ marginLeft: '4rem', display:"flex" }}>
                        <input
                            type="checkbox"
                            checked={way === 'normal'}
                            value="normal"
                            onChange={() => setWay('normal')}
                            style={{width:"15px", height:"20px", cursor:"pointer"}}
                        />
                        <div style={{margin:"auto", marginLeft: '0.5rem'}}>계좌이체</div>
                        {way === 'normal' && (
                            <div style={{ marginLeft: '1rem', marginTop:'5px', color: 'rgb(223, 60, 60)', fontSize:'0.9rem' }}>*해당 서비스는 법인 계좌를 통한 결제만 가능합니다.</div>
                        )}
                        </label>
                    </div>
                </div>

                {way === '1688' && (
                    <>
                <div className="intros-info" >
                    1688 확인 정보 입력
                </div>
                <div className="user-info" >
                <div className="information">
                <div className="info">1688 ID</div>
                    <input placeholder="1688 판매업체와 확인할 수 있는 정보를 입력해주세요" value={b} onChange={(event) => (setB(event.target.value))}/>
                </div>
                {cnLink.map((link, index) => (
                <div className="information" key={index}>
                            <div className="info" style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>제품 링크</div>
                            <input
                                placeholder="1688 제품의 링크를 입력해주세요."
                                value={link}
                                onChange={(e) => handleLinkChange(index, e.target.value)}
                                style={{ width:"50%" }}
                            />
                            <button
                                onClick={() => handleRemoveLink(index)}
                                disabled={index === 0}
                                style={{ marginLeft: '8px', height:"38px", width:"80px", cursor:"pointer", border:"none", borderRadius:"5px", backgroundColor:"rgb(209 116 116)", color:"white", fontWeight:"bold", cursor:"pointer" }}
                            >
                                삭제
                            </button>

                        </div>
                        ))}
                        <div style={{ marginTop: '8px' }}>
                            <button onClick={handleAddLink} disabled={cnLink.length >= 20} style={{width:"100px", height:"40px", border:"none", borderRadius:"5px", backgroundColor:"#1592ce", color:"white", fontWeight:"bold", cursor:"pointer"}}>
                            링크 추가
                            </button>
                        </div>
                </div>
                </>
                )}

                {way === 'normal' && (
                <>
                <div className="intros-info" >
                    계좌이체 확인 정보 입력
                </div>
                <div className="user-info" >
                <div className="information">
                <div className="info">예금주명 (입금 받는 사람)</div>
                    <input placeholder="입금 받을 계좌의 예금주명을 입력해주세요" value={owner} onChange={(event) => (setOwner(event.target.value))}/>
                </div>
                <div className="information">
                <div className="info">은행명</div>
                    <input placeholder="은행명을 입력해주세요" value={bank} onChange={(event) => (setBank(event.target.value))}/>
                </div>
                <div className="information">
                <div className="info">계좌번호</div>
                    <input placeholder="계좌번호를 입력해주세요" value={paycode} onChange={(event) => (setPaycode(event.target.value))}/>
                </div>
                </div>
                </>
                )}

                <div className="prd-info">

                <div className="informations">
                <div className="info">총 결제 요청 금액 (CNY)</div>
                    <input placeholder="*배송비를 포함한 위안화(元) 총 금액을 입력해주세요" value={i} type="number" onChange={(event) => (setI(event.target.value))} />
                </div>

                {/* <div className="informations">
                <div className="info">제품 정보</div>
                    <span style={{marginLeft:"15px", cursor: 'pointer', backgroundColor: '#007bff', color: 'white', padding: '10px 16px', borderRadius:'5px'}} onClick={openModal}>제품 정보 업로드</span>
                    <input style={{width:'65%'}} value={prds} readOnly/>
                </div>


                {isModalOpen && (
                    <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                        <h2>제품 정보 업로드</h2>
                        <button className="close-button" onClick={closeModal}>
                            &times;
                        </button>
                        </div>
                        <div className="modal-body">
                            {products.map((product, index) => (
                                <div key={product.id} className="product-card">

                                <DualSectionImageUploader
                                image={product.image}
                                onImageChange={(file, url) => {
                                    const updated = [...products];
                                    updated[index].image = url;
                                    setProducts(updated);
                                }}
                                onRemove={() => {
                                    const updated = [...products];
                                    updated[index].image = null;
                                    setProducts(updated);
                                }}
                                />


                                <div className="product-details">
                                    <input
                                    type="text"
                                    placeholder="제품명"
                                    value={product.name}
                                    onChange={(e) => handleInputChange(index, 'name', e.target.value)}
                                    />
                                    <input
                                    type="text"
                                    placeholder="제품 옵션"
                                    value={product.option}
                                    onChange={(e) => handleInputChange(index, 'option', e.target.value)}
                                    />
                                    <input
                                    type="number"
                                    placeholder="수량"
                                    value={product.quantity}
                                    onChange={(e) => handleInputChange(index, 'quantity', e.target.value)}
                                    />
                                    <input
                                    type="number"
                                    placeholder="단가"
                                    value={product.price}
                                    onChange={(e) => handleInputChange(index, 'price', e.target.value)}
                                    />
                                    <input
                                    type="number"
                                    placeholder="중국 현지 운임"
                                    value={product.cndelivery}
                                    onChange={(e) => handleInputChange(index, 'cndelivery', e.target.value)}
                                    />
                                    <input
                                    type="url"
                                    placeholder="*제품 URL"
                                    value={product.link}
                                    onChange={(e) => handleInputChange(index, 'link', e.target.value)}
                                    />
                                </div>


                                <div className="product-actions">
                                    <button
                                    onClick={() => removeProduct(index)}
                                    disabled={index === 0}
                                    style={{ color: index === 0 ? '#ccc' : 'red' }}
                                    >
                                    삭제
                                    </button>
                                </div>
                                </div>
                            ))}



                                <div style={{ marginTop: '10px', textAlign: 'center' }}>
                                {products.length < 10 && (
                                <button className="prdsbtn" onClick={addProduct}>+ 제품 추가</button>
                            )}
                                <button className="prdsbtns" onClick={closeModal}>완료</button>
                                </div>

                        </div>
                    </div>
                    </div>
                )} */}

                </div>

                <div className="informations-check">

                <div className="info k">중달이닷컴 배송대행 신청여부</div>
                <RadioGroup value={k} onChange={setK}>
                <Radio value="YES">YES</Radio>
                <Radio value="NO">NO</Radio>
                </RadioGroup>
                </div>


                <div className="prd-info">
                <div className="informations">
                <div className="info">비고</div>
                    <textarea placeholder="추가문의사항을 입력해주세요" value={l} type="text" spellCheck="false" maxLength={500} 
                    onKeyDown={(event) => {
                                 if (event.key === 'Enter') {
                                 event.preventDefault();
                                 setL(l + '\n');
                                 }
                                 }} onChange={(event) => (setL(event.target.value))}/>
                </div>

                </div>

                <div className="agree-info">
                <Agreebox checked={m} onChange={setM}>
                    <span>*</span>주의사항을 모두 숙지하였으며, 결제대행을 신청합니다.
                </Agreebox>
                </div>
                
                <div className="submit-info">
                <span
                onClick={handleNextClick}>다음으로</span>
                </div>

                

            </div>
          
        )
    }else if (page === 1) {
        return(
            <>

            {loading && <div className="loading">
            <span></span> 
            <span></span>
            <span></span>  
            </div>}

            <div className="purchase-form-body" style={{ height:"1240px"}}>

                <div className="prcResult">

                </div>
                
                <div className="prcCanvas" style={{position:"absolute"}}>
                <div className="contentAreaPrc">
                    <div className="headerAreaPrc">
                        <div className="headerArea-leftPrc"><div className="logoimgPrc"><img src={LogoImageUrl}/></div></div>
                        <div className="headerArea-rightPrc" style={{textAlign:"left"}}>Tel. 070-7776-1688 / Fax. 032-714-3850 / E-mail. pi@jungdari.com<br/>2702-2703 Sambo Techno Tower 122, Jomaru-ro 385 Beon-gil, Bucheon-si, Gyeonggi-do, Korea</div>
                    </div>

                    <div className="mainAreaPrc">
                        <div className="mainArea-topPrc">
                            <div className="mainArea-top-leftPrc">결제대행 서비스 수수료 청구서</div>
                            <div className="mainArea-top-rightPrc">
                                <div className="topArea-right-aPrc">
                                    <div className="rightArea-a-titlePrc"></div>
                                    <div className="rightArea-a-contentPrc"></div>
                                </div>
                                <div className="topArea-right-bPrc">
                                    <div className="rightArea-b-titlePrc"></div>
                                    <div className="rightArea-b-contentPrc"></div>
                                </div>
                            </div>
                            </div>
                        </div>
               

                <div className="mainArea-middlePrc">
                    <div className="mainArea-middle-onePrc">
                        <div className="middleArea-one-aPrc">
                        고객정보
                        </div>
                    </div>
                    <div className="mainArea-middle-twoPrc">
                        <div className="middleArea-two-aPrc">
                            <div className="twoArea-a-titlePrc" style={{textAlign:"left"}}>신청자명</div>
                            <div className="twoArea-a-contentPrc" style={{textAlign:"left"}}>{c}</div>
                        </div>
                        <div className="middleArea-two-aPrc">
                            <div className="twoArea-a-titlePrc" style={{textAlign:"left"}}>연락처</div>
                            <div className="twoArea-a-contentPrc" style={{textAlign:"left"}}>{e}</div>
                        </div>
                    </div>
                    <div className="mainArea-middle-threePrc">
                        <div className="middleArea-three-aPrc">
                            <div className="threeArea-a-titlePrc" style={{textAlign:"left"}}>이메일</div>
                            <div className="threeArea-a-contentPrc" style={{textAlign:"left"}}>{f}</div>
                        </div>
                        <div className="middleArea-three-aPrc">
                            <div className="threeArea-a-titlePrc" style={{textAlign:"left"}}>중달이닷컴 ID</div>
                            <div className="threeArea-a-contentPrc" style={{textAlign:"left"}}>{g}</div>
                        </div>
                    </div>
                    <div className="mainArea-middle-fourPrc">
                        <div className="middleArea-four-aPrc">
                            <div className="fourArea-a-titlePrc" style={{textAlign:"left"}}></div>
                            <div className="fourArea-a-contentPrc" style={{textAlign:"left", overflowX:'hidden'}}></div>
                        </div>
                    </div>
                    <div className="mainArea-middle-onePrc">
                        <div className="middleArea-one-aPrc">
                        결제 정보
                        </div>
                    </div>
                    <div className="mainArea-middle-twoPrc" style={{fontSize:"20px"}}>
                        <div className="middleArea-two-aPrc">
                            <div className="twoArea-a-titlePrc" style={{textAlign:"left"}}>제품가 (¥)</div>
                            <div className="twoArea-a-contentPrc" style={{textAlign:"left"}}>{i}</div>
                        </div>
                        <div className="middleArea-two-aPrc">
                            <div className="twoArea-a-titlePrc" style={{textAlign:"left"}}>환율</div>
                            <div className="twoArea-a-contentPrc" style={{textAlign:"left"}}>{z}</div>
                        </div>
                    </div>
                </div>

                <div className="mainArea-bottomPrc">
                    <div className="mainArea-bottom-onePrc">
                    아래와 같이 서비스 수수료를 청구합니다.
                    </div>
                </div>


                    <div className="authForm-two-wPrc" style={{marginTop:"20px"}}>
                            <div className="w-inner-leftPrc">
                                <div className="wLeft-inner-topPrc">
                                <span style={{fontWeight:"600"}}>일 자</span>
                                <span style={{fontWeight:"400"}}>{date}</span>
                                </div>
                                <div className="wLeft-inner-bottomPrc" style={{paddingTop:"10px"}}>
                                <span style={{fontWeight:"600"}}>담당자</span>
                                <span style={{fontWeight:"400"}}>(주)빅파이씨앤티</span>
                                </div>
                            </div>
                            <div className="w-inner-rightPrc">
                                <div className="wRight-inner-middlePrc" >
                                <div style={{color:"rgb(9, 158, 228)", flex:"1",  color:"rgb(223, 171, 60)", textAlign:"left"}}>제품가</div>
                                <div style={{paddingLeft:"20px", flex:"1", textAlign:"right"}}>￦ {valueComma(t)}</div>
                                </div>
                            </div>
                    </div>

                    <div className="authForm-two-wPrc">
                            <div className="w-inner-leftPrc">
                                <div className="wLeft-inner-topPrc">
                                <span style={{fontWeight:"600", color:"white"}}>  '''''''lllll</span>
                                <span style={{fontWeight:"400"}}>중국1688구매대행</span>
                                </div>
                                <div className="wLeft-inner-bottomPrc">
                                <span style={{fontWeight:"600"}}></span>
                                <span style={{fontWeight:"400"}}></span>
                                </div>
                            </div>
                            <div className="w-inner-rightPrc">
                                <div className="wRight-inner-middlePrc">
                                <div style={{color:"rgb(9, 158, 228)", flex:"1",  color:"black", textAlign:"left"}}>수수료</div>
                                <div style={{paddingLeft:"20px", flex:"1", textAlign:"right"}}>￦ {valueComma(o)}</div>
                                </div>
                            </div>
                    </div>

                    <div className="authForm-two-wPrc">
                            <div className="w-inner-leftPrc">
                                <div className="wLeft-inner-topPrc">
                                <span style={{fontWeight:"600"}}></span>
                                <span style={{fontWeight:"400"}}></span>
                                </div>
                                <div className="wLeft-inner-bottomPrc">
                                <span style={{fontWeight:"600"}}></span>
                                <span style={{fontWeight:"400"}}></span>
                                </div>
                            </div>
                            <div className="w-inner-rightPrc">
                                <div className="wRight-inner-middlePrc">
                                <div style={{color:"rgb(9, 158, 228)", flex:"1", color:"black", textAlign:"left"}}>부가세 (수수료 x 10%)</div>
                                <div style={{paddingLeft:"20px", flex:"1", textAlign:"right"}}>￦ {valueComma(p)}</div>
                                </div>
                            </div>
                    </div>

                    <div className="authForm-two-wPrc">
                            <div className="w-inner-leftPrc">
                                <div className="wLeft-inner-topPrc">
                                <span style={{fontWeight:"600"}}></span>
                                <span style={{fontWeight:"400"}}></span>
                                </div>
                                <div className="wLeft-inner-bottomPrc">
                                <span style={{fontWeight:"600"}}></span>
                                <span style={{fontWeight:"400"}}></span>
                                </div>
                            </div>
                            <div className="w-inner-rightPrc">
                                <div className="wRight-inner-middlePrc">
                                <div style={{color:"rgb(9, 158, 228)", flex:"1", fontWeight:"800", textAlign:"left"}}>총 금 액 (VAT포함)</div>
                                <div style={{paddingLeft:"20px", flex:"1", textAlign:"right"}}>￦ {valueComma(rr)}</div>
                                </div>
                            </div>
                    </div>

                    <div className="footerAreaPrc" style={{marginTop:"20px"}}>
                        <div className="footerArea-onePrc">
                        <div className="footerArea-one-aPrc"><span className="spanArea-aPrc">입금 계좌: 기업은행 296-116060-01-011 이중엽(중국1688구매대행)</span><span className="spanArea-bPrc" style={{fontWeight:"400", fontSize:"16px", marginTop:"2px"}}>해당 계좌로 입금 부탁드립니다.</span></div>
                        <div className="footerArea-one-bPrc" style={{fontSize:"16px", marginTop:"20px"}}>
                        입금하신 금액 확인 후 세금계산서(현금영수증) 발행됩니다. (비고 : 수수료 + 부가세)</div>
                        </div>
                    </div>

            
            
            </div>

                    

                </div>

                <div className="prcForm">

                    <div className="prcForm-first">
                        <div style={{display:"block", margin:"auto"}}>
                        <div className="prcForm-first-title">수수료 확인 및 결제</div>
                        <div className="prcForm-first-content">아래 신청내역을 확인해주세요</div>
                        </div>
                    </div>
                
                <div>

                <div className="mainArea-middlePrc" style={{padding:"30px"}}>
                <div className="mainArea-middle-twoPrc">
                        <div className="middleArea-two-aPrc">
                            <div className="twoArea-a-titlePrc" style={{textAlign:"left"}}>신청자명</div>
                            <div className="twoArea-a-contentPrc" style={{textAlign:"left", borderLeft:"1px solid #b9b9b9", paddingLeft:"20px"}}>{c}</div>
                        </div>
                        <div className="middleArea-two-aPrc">
                            <div className="twoArea-a-titlePrc" style={{textAlign:"left"}}></div>
                            <div className="twoArea-a-contentPrc" style={{textAlign:"left", borderLeft:"1px solid #b9b9b9", paddingLeft:"20px"}}></div>
                        </div>
                    </div>
                    <div className="mainArea-middle-threePrc">
                        <div className="middleArea-two-aPrc">
                            <div className="twoArea-a-titlePrc" style={{textAlign:"left"}}>연락처</div>
                            <div className="twoArea-a-contentPrc" style={{textAlign:"left", borderLeft:"1px solid #b9b9b9", paddingLeft:"20px"}}>{e}</div>
                        </div>
                        <div className="middleArea-three-aPrc">
                            <div className="threeArea-a-titlePrc" style={{textAlign:"left"}}>이메일</div>
                            <div className="threeArea-a-contentPrc" style={{textAlign:"left", borderLeft:"1px solid #b9b9b9", paddingLeft:"20px"}}>{f}</div>
                        </div>
                    </div>
                    <div className="mainArea-middle-threePrc">
                        <div className="middleArea-three-aPrc">
                            <div className="threeArea-a-titlePrc" style={{textAlign:"left"}}>중달이닷컴 ID</div>
                            <div className="threeArea-a-contentPrc" style={{textAlign:"left", borderLeft:"1px solid #b9b9b9", paddingLeft:"20px"}}>{g}</div>
                        </div>
                        <div className="middleArea-three-aPrc">
                            <div className="threeArea-a-titlePrc" style={{textAlign:"left"}}>배송대행 신청유무</div>
                            <div className="threeArea-a-contentPrc" style={{textAlign:"left", borderLeft:"1px solid #b9b9b9", paddingLeft:"20px"}}>{k}</div>
                        </div>
                    </div>
                    <div className="mainArea-middle-threePrc">
                        <div className="middleArea-two-aPrc">
                            <div className="twoArea-a-titlePrc" style={{textAlign:"left"}}>중달이 고시환율</div>
                            <div className="twoArea-a-contentPrc" style={{textAlign:"left", borderLeft:"1px solid #b9b9b9", paddingLeft:"20px"}}>{z}</div>
                        </div>
                        <div className="middleArea-three-aPrc">
                            <div className="threeArea-a-titlePrc" style={{textAlign:"left"}}></div>
                            <div className="threeArea-a-contentPrc" style={{textAlign:"left", borderLeft:"1px solid #b9b9b9", paddingLeft:"20px"}}></div>
                        </div>
                    </div>
                    <div className="mainArea-middle-fourPrc">
                        <div className="middleArea-four-aPrc">
                            <div className="fourArea-a-titlePrc" style={{textAlign:"left"}}></div>
                            <div className="fourArea-a-contentPrc" style={{textAlign:"left", paddingLeft:"20px", overflowX:'hidden', borderLeft:"1px solid #b9b9b9"}}></div>
                        </div>
                    </div>


                </div>
            </div>
           

            <div className="authForm-two-wPrc" style={{marginTop:"20px"}}>
                            <div className="w-inner-leftPrc">
                                <div className="wLeft-inner-topPrc">
                                <span style={{fontWeight:"600"}}>일 자</span>
                                <span style={{fontWeight:"400"}}>{date}</span>
                                </div>
                                <div className="wLeft-inner-bottomPrc" style={{paddingTop:"10px"}}>
                                <span style={{fontWeight:"600"}}>담당자</span>
                                <span style={{fontWeight:"400"}}>(주)빅파이씨앤티</span>
                                </div>
                            </div>
                            <div className="w-inner-rightPrc">
                                <div className="wRight-inner-middlePrc" >
                                <div style={{color:"rgb(9, 158, 228)", flex:"1",  color:"rgb(223, 171, 60)", textAlign:"left"}}>제품가</div>
                                <div style={{paddingLeft:"20px", flex:"1", textAlign:"right"}}>￦ {!t && <span>산출중..</span>} {valueComma(t)}</div>
                                </div>
                            </div>
                    </div>

                    <div className="authForm-two-wPrc">
                            <div className="w-inner-leftPrc">
                                <div className="wLeft-inner-topPrc">
                                <span style={{fontWeight:"600", color:"#fff"}}>  '''''''lllll</span>
                                <span style={{fontWeight:"400"}}>중국1688구매대행</span>
                                </div>
                                <div className="wLeft-inner-bottomPrc">
                                <span style={{fontWeight:"600"}}></span>
                                <span style={{fontWeight:"400"}}></span>
                                </div>
                            </div>
                            <div className="w-inner-rightPrc">
                                <div className="wRight-inner-middlePrc">
                                <div style={{color:"rgb(9, 158, 228)", flex:"1",  color:"black", textAlign:"left"}}>수수료</div>
                                <div style={{paddingLeft:"20px", flex:"1", textAlign:"right"}}>￦ {!o && <span>산출중..</span>} {valueComma(o)}</div>
                                </div>
                            </div>
                    </div>

                    <div className="authForm-two-wPrc">
                            <div className="w-inner-leftPrc">
                                <div className="wLeft-inner-topPrc">
                                <span style={{fontWeight:"600"}}></span>
                                <span style={{fontWeight:"400"}}></span>
                                </div>
                                <div className="wLeft-inner-bottomPrc">
                                <span style={{fontWeight:"600"}}></span>
                                <span style={{fontWeight:"400"}}></span>
                                </div>
                            </div>
                            <div className="w-inner-rightPrc">
                                <div className="wRight-inner-middlePrc">
                                <div style={{color:"rgb(9, 158, 228)", flex:"1",  color:"black", textAlign:"left"}}>견적금액</div>
                                <div style={{paddingLeft:"20px", flex:"1", textAlign:"right"}}>￦ {!q && <span>산출중..</span>} {valueComma(q)}</div>
                                </div>
                            </div>
                    </div>

                    <div className="authForm-two-wPrc">
                            <div className="w-inner-leftPrc">
                                <div className="wLeft-inner-topPrc">
                                <span style={{fontWeight:"600"}}></span>
                                <span style={{fontWeight:"400"}}></span>
                                </div>
                                <div className="wLeft-inner-bottomPrc">
                                <span style={{fontWeight:"600"}}></span>
                                <span style={{fontWeight:"400"}}></span>
                                </div>
                            </div>
                            <div className="w-inner-rightPrc">
                                <div className="wRight-inner-middlePrc">
                                <div style={{color:"rgb(9, 158, 228)", flex:"1", color:"black", textAlign:"left"}}>부가세 (수수료 x 10%)</div>
                                <div style={{paddingLeft:"20px", flex:"1", textAlign:"right"}}>￦ {!p && <span>산출중..</span>} {valueComma(p)}</div>
                                </div>
                            </div>
                    </div>

                    <div className="authForm-two-wPrc">
                            <div className="w-inner-leftPrc">
                                <div className="wLeft-inner-topPrc">
                                <span style={{fontWeight:"600"}}></span>
                                <span style={{fontWeight:"400"}}></span>
                                </div>
                                <div className="wLeft-inner-bottomPrc">
                                <span style={{fontWeight:"600"}}></span>
                                <span style={{fontWeight:"400"}}></span>
                                </div>
                            </div>
                            <div className="w-inner-rightPrc" style={{borderTop:"1px solid #dbdbdb"}}>
                                <div className="wRight-inner-middlePrc">
                                <div style={{color:"rgb(9, 158, 228)", flex:"1", fontWeight:"800", textAlign:"left"}}>총 금 액 (VAT포함)</div>
                                <div style={{paddingLeft:"20px", flex:"1", textAlign:"right"}}>￦ {!r && <span>산출중..</span>} {valueComma(r)}</div>
                                </div>
                            </div>
                    </div>

                    <div style={{padding:"30px"}}>
                    <div className="footerAreaPrc" style={{marginTop:"20px"}}>
                        <div className="footerArea-onePrc">
                        <div className="footerArea-one-aPrc"><span className="spanArea-aPrc">입금 계좌: 기업은행 296-116060-01-011 이중엽(중국1688구매대행)</span></div>
                        <div className="footerArea-one-bPrc">
                        입금하신 금액은 수입 후 전액 세금계산서 발행됩니다.</div>
                        </div>
                    </div>
                    </div>

                    <div className="authForm-two-r">
                    <div className="r-inner-content">
                            <button type="submit"
                            disabled={loading}
                            style={{border:"none"}}
                        >{loading ? '제출중..' : '제출하기'}</button>

                        <button
                        style={{background:"#9b9b9b", border:"none"}}
                        onClick={() => {
                            setPage((currPage) => currPage - 1);
                        }}
                        >수정하기</button>
                    </div>
                    </div>



            </div>

            </div>

            </>
        )
    }else if (page === 2) {
        return(
            <div className="authForm-two-x">


            <div className="x-inner" style={{marginTop:"18%"}}>
            <div className="x-inner-title">
            신청이 완료되었습니다.
            </div>
            <div className="x-inner-text">
            <strong>신청내역 및 청구서는 고객님 이메일로 발송</strong>되었습니다.
            </div>
            <div style={{textAlign:"center", paddingTop:"20px", color:"grey"}}>
            이메일을 받지 못하셨다면, 이메일 수신함의 스팸 메일함을 확인해보세요
            </div>
            <div className="x-inner-content">
            <a href="https://jungdari.com/"
            rel="noopener noreferrer">
            <span>홈으로</span>
            </a>
            </div>
            </div>
            </div>
        )
    }
}

  return (
<div className="purchase-full">

<div className="purchase-nav">
<a href="https://www.jungdari.com/"
       rel="noopener noreferrer">
      <img src={Logo} alt="Logo" style={{ width: "140px", padding:"10px 0px", paddingLeft:"14px"}} />
    </a>
    <ul className="purchase-ul">
    <li style={{ display: "inline-block" }}>
    </li>
    <li style={{ display: "inline-block", marginLeft: "9rem" }}>
    </li>
    <li style={{ display: "inline-block", marginLeft: "9rem" }}>
    </li>
    <li style={{ display: "inline-block", marginLeft: "9rem" }}>
    </li>

    <li className="purchase-signup">
    <Link to="/purchase">
      중달이닷컴 회원가입
    </Link>
    </li>
    </ul>
</div>

<div className="purchase-banner">

  <div className="purchase-banner-imgTwo">

  </div>

</div>

<div className="purchase-bodys">
    <div className="purchase-block-eight">
    <form onSubmit={onSubmit}>
        {Pages()}
    </form>
    </div>
</div>

<div className={`purchase-block-seven ${page === 0 ? 't' : ''}`}>

    <div className="block-seven-text">

    <div className="seven-top">

        <div className="seven-left">
    <a href="https://jungdari.com/suport/terms.do"
         target="_blank"
         rel="noopener noreferrer">이용약관</a>&nbsp;&nbsp;|&nbsp;&nbsp;  
        <a href="https://jungdari.com/suport/privacy.do"
         target="_blank"
         rel="noopener noreferrer">개인정보취급방침</a>
        &nbsp;&nbsp;|&nbsp;&nbsp;               
        <a href="https://jungdari.com/suport/terms2.do"
         target="_blank"
         rel="noopener noreferrer">개인정보의 수집 및 이용목적</a>
         </div>

         <div className="seven-right">
        고객문의 070-7776-1688
        </div>
    </div>

    <div className="seven-bottom">

        <div className="footer">

        <div className="footer-left">
    <p>상호:(주)빅파이씨앤티 | 사업자 등록번호 : 169-81-00496 | 전화번호 : 070-7776-1688 | 팩스번호 : 032-714-3850</p>
    <p>경기도 부천시 조마루로 385번길 122 삼보테크노타워 2702-3호 (주)빅파이씨앤티</p>
    <p>대표이사: 이중엽 | 통신판매 신고번호 : 제 2021-경기부천-1209호 | 개인정보보호책임자 : 양지연 | 메일: pi@jungdari.com</p>
    <p>Copyrights2020ⓒBigpieC&T. All Rights Reserved</p>
    </div>

    <div className="footer-right">
        <div className="footer-img"></div>
    </div>

    </div>

    </div>
    </div>
      
  </div>

</div>
  );
}

export default PurchaseForm;
